import {
    Box, Text,
    useColorModeValue as mode, useMediaQuery
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";


export const GiftGuide = ({title, description, bg, style=undefined as any, ...rest}) => {

    const [isTooSmall] = useMediaQuery("(max-width: 1000px)");

    return (
        <Box mt={20} mb={10} bg={bg} maxW="300px" p={5} borderRadius="12px" position="relative" {...rest}>
            <Text
                p={2}
                pr={4}
                pl={4}
                borderRadius="22px" 
                position="absolute"
                top="-30px"
                // right="-20px"
                left="50%" transform="translateX(-50%)"
                bg={"white"}
                color={"#1E1E1E"}
                textAlign="center"
                fontWeight="600"
                fontSize="sm"
                border={"1mm solid " + theme.colors.gray[700]}
                {...style?.title}
            >
                {title}
            </Text>
            <Text
                color={mode("gray.300", "gray.300")}
                textAlign="center"
                fontWeight="600"
                {...style?.description}
            >
                {/* Our 25+ pages <Link textDecoration="underline" href="https://ponyexpress.gumroad.com/l/twittergrowthguide" target="_blank">Twitter Growth Guide</Link> 📕 (valued $49) */}
                {description}
            </Text>
        </Box>
    );
}